import { imageFile } from 'common/helpers/miscHelper';

const ClubImage = (props) => {
  const { club, size = 'large', width } = props;

  if (!club.image) {
    return null;
  }

  const image = imageFile(club.image, size);

  return <img src={image} alt={club.title} width={width} />;
};

export default ClubImage;
